import api from "./api";
import { tokenStorage } from "../utils/tokenStorage";

/** Wraps the browser geolocation API in a promise. */
function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("Geolocation is not available on this device."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      () =>
        reject(
          new Error(
            "Location is disabled! Please switch on the location service and reload the page."
          )
        )
    );
  });
}

const AttendanceService = {
  getCurrentPosition,

  /**
   * Marks a Check In / Check Out record for the current user at the
   * scanned QR location (lid = location id, bid = branch id).
   *
   * IMPORTANT: this must send the exact same X-My-Secret-Token that was
   * generated (from the .env secret key) during login - not a fresh one -
   * or the backend rejects the request. We read it straight from
   * tokenStorage and attach it explicitly on this call.
   */
  async postAttendance({ latitude, longitude, lid, bid, attendType, overNight }) {
    const token = tokenStorage.get();
    if (!token) {
      throw new Error("You're not logged in. Please sign in again.");
    }

    const { data } = await api.post("/QrRetrieve/PostUserLocation", null, {
      headers: { "X-My-Secret-Token": token },
      params: {
        longitute: longitude,
        latitute: latitude,
        LocId: lid,
        BId: bid,
        attendType,
        overNight: overNight ? "Y" : "N",
      },
    });

    return data;
  },
};

export default AttendanceService;
